import React from 'react'

import { Outlet } from 'react-router-dom'
import { OutletWrapper } from '@base'

const AdminAuction = () => {
	return (
		<OutletWrapper>
			<Outlet />
		</OutletWrapper>
	)
}

export default AdminAuction
